// sample API structure
export const loginUser = async () => {
    globalThis.location.replace(`${process.env.REACT_APP_API_URL}auth/login/`);
};